import { renewalSummaryQueries } from '@queries/fetchRenewalSummary';
import type { GetRenewalSummaryResponse } from '@responses/renewal-summary';
import { useQuery } from '@tanstack/react-query';

import { JOB_IN_FLIGHT, POLL_INTERVAL_MS } from '../constants';

/** Polls every 3s while a job is in flight, otherwise fetches once. Shared by the panel and the header. */
export const pollWhileInFlight = (data: GetRenewalSummaryResponse | undefined): number | false =>
  data?.job && JOB_IN_FLIGHT[data.job.status] ? POLL_INTERVAL_MS : false;

export const useRenewalSummaryQuery = (renewalId: string, enabled: boolean) =>
  useQuery({
    ...renewalSummaryQueries.detail(renewalId),
    enabled: enabled && Boolean(renewalId),
    refetchInterval: (query) => pollWhileInFlight(query.state.data),
  });
